<template>
    <div id="app" class="container">
        
        <div class="nav nav-pills">
          <li class="nav-item">
            <router-link to='/' class="nav-link" exact>Inicio</router-link>
          </li>

          <li class="nav-item">
            <router-link to='/blog' class="nav-link">Blog</router-link>
          </li>

          <li class="nav-item">
            <router-link to='/suscripciones' class="nav-link">Suscripciones</router-link>
          </li>

          <li class="nav-item">
            <router-link to='/registros' class="nav-link">Registros</router-link>
          </li>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }

  .router-link-active {
    background: #025aa5;
    color: #fff;
  }

  .nav-pills li a:focus{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// App.vue?4acaaade